<template>
	<v-slide-x-transition>
		<v-overlay :value="show" opacity="0" style="min-height: 360px; z-index: 9999">
			<v-card rounded light class="pa-4 text-center" elevation="16">
				<img src="img/primarLoading.gif" alt="Loading" />
				<p class="mb-0">
					<small>Loading.. please wait</small>
				</p>
			</v-card>
		</v-overlay>
	</v-slide-x-transition>
</template>

<script>
export default {
	name: 'LoadingAnimation',
	props: {
		show: Boolean,
	},
	loaderImage: import('@/assets/primarLoading.gif'),
}
</script>